import { Component, OnInit, Input, ViewChild, OnDestroy, ElementRef } from '@angular/core';
import { StageSandbox } from '../../services/stage.sandbox';

import * as stageTypes from '../../types';
import * as animations from '../../../shared/animations';
import * as commonTypes from '../../../shared/types';
import * as _ from 'lodash';
import { QUESTION_TYPES } from '../../types/constants';

import { Subscription, Observable } from 'rxjs/Rx';

@Component({
  selector: 'tr-final-confirmation-container',
  templateUrl: './final-confirmation-container.component.html',
  //styleUrls: ['./final-confirmation-container.component.scss']
})
export class FinalConfirmationContainerComponent implements OnInit {
  @Input() entity: stageTypes.IPage;
  
  private currentStageId$: Observable<number> = this.sb.getCurrentStageId$();
  private subscriptions: Array<Subscription> = [];
  private currentAction: string = '';
  private blockContainers: stageTypes.IContainerDef[] = [];

  constructor(private sb: StageSandbox) { }

  ngOnInit() {
    this.blockContainers = [].concat(this.sb.groupElements(this.entity));
  }

  isDownloading$(questionId: string): Observable<boolean> {
    return this.sb.getFileDownloadingStatus$(questionId, this.currentAction);
  }

  viewedDocumentStatus$(questionId: number): Observable<boolean> {
    return this.sb.getFileReadingStatus$(questionId);
  }

  getFileContent$(questionId: number): Observable<any> {
    return this.sb.getFileContent$(questionId);
  }


  currentAction$(): Observable<string> {
    return Observable.of(this.currentAction);
  }

  onElementAction(actionName: string, question: stageTypes.IHtmlElement) {
    this.currentAction = actionName.toLowerCase();
    this.subscriptions.push(
      this.sb.onDocumentAction(actionName, question.id)
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/stage/containers/final-confirmation-container/final-confirmation-container.component.ts